import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "components/Common/Sidebar";
import NavigationBar from "components/Common/NavigationBar";
import GlobalHeader from "./Common/GlobalHeader";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Spin } from "antd";

function MainPage() {
  const menuGroupList = useSelector((state) => state.etcReducer.menuGroupList);
  const authState = useSelector((state) => state.mainReducer.authState);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authState) {
      navigate("/login");
    }
  }, [authState, navigate]);

  useEffect(() => {
    if (menuGroupList && menuGroupList.length === 0) {
      setLoading(true);
    }
    setLoading(false);
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width:"100%",
        height:"100%"
      }}
    >
      <GlobalHeader />
      <div style={{ display: "flex", flex: "1 0 auto"}}>
        <Sidebar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "10px",
            flexGrow: 1,
          }}
        >
          <NavigationBar />
          <div
            style={{
              display: "flex",
              flex: "1 0 auto",
              height: "100px",
              overflow: "auto"
            }}
          >
            <div style={{flex:"1 0 auto", width:"100px"}}>
            <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
